<template>
  <div class="export-pdf">
    <div id="pdfDom" >
      <h1>{{htmlTitle}}</h1>
      <div class="component-wrapper" v-for="(its, idx) in questionList" :key="idx">
        <!-- 添加索引显示 -->
        <div v-if="showIndex">
          <span >{{ idx + 1 }}.</span>
        </div>
        <component :is="its.echo" :form="its" @onRenderComplete="mathjaxRes" ></component>
      </div>
    </div>

  </div>
</template>

<script>
import transform from './transition.js'
import { getHomeworksDetail } from "@/api/homeworks";
import { toSnakeCase } from '@/utils/data-format'

export default {
  components: {
    ...transform,
  },
  data() {
    return {
      convertType: [
        'ChoiceEcho',
        'DetermineEcho',
        'FillingBlanksEcho',
        'SumEcho',
        'HotspotEcho',
        'TextDragEcho',
        'LigatureEcho',
        'ImgDragEcho',
        'SumEcho',
        'TextDragEcho2',
      ],
      questionList: [],
      htmlTitle: "测试导出文件", // 生成pdf的名称
      showIndex: true, // 控制是否显示索引

      mathjaxNum: 0,
      endTime: 0,
      t: null,
      A4PageHeight: 0
    }
  },
  methods: {
    mathjaxRes() {
      this.mathjaxNum ++
    },
    init(title, id) {
      this.htmlTitle = title
      this.mathjaxNum = 0
      getHomeworksDetail(id).then(res => {
        res.data.questions.filter(its => {
          its.echo = this.convertType[its.type]
        })
        this.questionList = toSnakeCase(res.data.questions)

        this.timer()
      })
    },
    // 计时器
    timer() {
      this.t = setInterval(() => {
        this.endTime ++
        if(this.endTime == this.questionList.length * 3) {
          this.exportPdf()
        }

      }, 1000)
    },
    exportPdf() {
      let components = document.querySelectorAll('.component-wrapper'),
          totalHeight = 0,
          pageNum = 1

      for(let i = 0; i < components.length; i++) {
        let cpt = components[i],
            curCptHeight = cpt.offsetHeight

        if((curCptHeight + totalHeight) > pageNum * this.A4PageHeight) {
          let val = pageNum * this.A4PageHeight - totalHeight
          cpt.style.paddingTop = `${val}px`
          totalHeight += val
          pageNum ++
        }
        totalHeight += curCptHeight
      }

      clearInterval(this.t)
      this.t = null
      this.endTime = 0
      setTimeout(() => {
        this.getPdf()
        this.$emit('closeLoading')
      }, 1000);
    }
  },
  mounted() {
    let pdfDom = document.querySelector('#pdfDom'),
        width = pdfDom.offsetWidth
    this.A4PageHeight = Math.ceil(width * (841.89 / 592.28))
  }
}
</script>

<style scoped lang="scss">
.export-pdf {
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  #pdfDom {
    width: 1000px;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .component-wrapper {
    display: flex;
    margin-bottom: 20px;

    .question-index {
      margin-right: 10px;
      padding-top: 10px;

      .index-number {
        font-size: 16px;
        font-weight: bold;
        color: #333;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
// 保持原有样式不变
.export-pdf {
  .question-view {
    .block-style {
      width: 80px;
      height: 80px;
      position: absolute;
      top: 80px;
      left: 80px;
      cursor: pointer;
      z-index: 1;
      background-size: 100% 100%;
      border: 1px solid #333;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

      }

      .success, .error {
        position: absolute;
        bottom: -5px;
        right: -5px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #007416;
        display: none;
      }

      .success {
        &:before {
          content: '';
          color: #fff;
          position: absolute;
          top: -5px;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: 10px;
          height: 6px;
          border: 2px solid #fff;
          border-top: none;
          border-right: none;
          transform: rotateZ(-50deg);
          transform-origin: center center;
        }
      }

      .error {
        background-color: #d60215;

        &:before, &:after {
          content: '';
          width: 10px;
          height: 2px;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          transform: rotateZ(-45deg);
          transform-origin: center center;
          background-color: #fff;
        }

        &:after {
          transform: rotateZ(45deg);
        }
      }
    }
  }
}
</style>